<template>
  <section class="testimonials bg-white rounded-19 p-5 sm:p-10 xl:p-[70px]">
    <div class="mx-auto w-64 sm:w-76 md:w-60 1.5md:w-[360px]">
      <div ref="testimonialCarousel" class="owl-carousel owl-theme">
        <div v-for="testimonial in testimonials" :key="testimonial.name" class="item py-5">
          <img
            class="img-circle rounded-full w-12 h-12 sm:w-14 sm:h-14 md:h-[50px] md:w-[50px] 1.5md:h-[70px] 1.5md:w-[70px] bg-white border border-white"
            :src="testimonial.image"
            alt="image"
          />
          <div class="hidden">
            <p class="center-testimonial">{{ testimonial }}</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="my-12.5 text-center min-h-[140px]">
        <p1>{{ testimonialCardText }}</p1>
      </div>
      <div class="flex flex-col items-center">
        <h4>{{ testimonialCardName }}</h4>
        <p2 class="mt-1.5 mb-4">{{ testimonialCardDesignation }}</p2>
        <div class="flex">
          <span v-for="(n, index) in 5" :key="index">
            <Icon icon="rateStar" :color="getStarColor(index)" />
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue'
import Icon from '@src/components/icons/icon.vue'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'
import 'owl.carousel'

export default {
  components: {
    Icon,
  },
  setup() {
    const testimonialCarousel = ref(null)
    const testimonialCardText = ref('')
    const testimonialCardName = ref('')
    const testimonialCardDesignation = ref('')
    const testimonialCardReviewRateing = ref(0)

    const getStarColor = (index) => {
      return index < parseInt(testimonialCardReviewRateing.value)
        ? 'warning-400'
        : 'primary-gray-300'
    }
    const testimonials = [
      {
        image: require('@src/assets/images/HomePage/avatar-1.png'),
        text: 'Previous school management software was expensive and difficult to use. MyQampus has proven to be a much better fit for both staff.',
        name: 'David Andrew',
        designation: 'Head of Strategy at DMPI',
        reviewRateing: 4,
      },
      {
        image: require('@src/assets/images/HomePage/avatar-2.png'),
        text: 'I got immediate notifications of changes in curriculum, timetable, etc. by the administration.',
        name: 'Agha Ali',
        designation: 'Superintendent',
        reviewRateing: 5,
      },
      {
        image: require('@src/assets/images/HomePage/avatar-3.png'),
        text: 'This cloud-based database software allows you to stay informed about faculty and student attendance at all times.',
        name: 'Dilawer Ali',
        designation: 'Principal',
        reviewRateing: 5,
      },
      {
        image: require('@src/assets/images/HomePage/avatar-5.png'),
        text: "I'd want to express my gratitude for the fantastic MyQampus services and features. Its user interface and graphical depiction of each feature are really fantastic. Everyone in the educational field should try this software.",
        name: 'Jeni Far',
        designation: 'Teacher',
        reviewRateing: 4,
      },
      {
        image: require('@src/assets/images/HomePage/avatar-6.png'),
        text: 'It is an excellent software to bring transparency in the educational system for everyone. A trustworthy, 24/7 available and easy to use platform to upgrade whole educational system. I Highly recommend this.',
        name: 'Naheed Hanif',
        designation: 'Academic coordinator',
        reviewRateing: 4,
      },

      {
        image: require('@src/assets/images/HomePage/avatar-10.jpeg'),
        text: 'I had been looking for an all-in-one institute management solution for a long time. The inclusion of #MyQampus in my professional life is a blessing. My entire educational endeavour is now in my hands.',
        name: 'Fang Lei',
        designation: 'Academic adviser',
        reviewRateing: 4,
      },
      {
        image: require('@src/assets/images/HomePage/avatar-12.png'),
        text: 'It is a very user friendly interface, making day to day tasks easier and quicker. Tech savy and highly recommended.',
        name: 'Fatima Pervaiz',
        designation: 'Teacher',
        reviewRateing: 5,
      },
    ]
    const updateActiveTestimonial = () => {
      const activeCenterCarousel = document.querySelector('.testimonials .owl-item.active.center')
      if (activeCenterCarousel) {
        const centerCarousel = JSON.parse(
          activeCenterCarousel.querySelector('.center-testimonial').textContent,
        )
        testimonialCardText.value = centerCarousel ? centerCarousel.text : ''
        testimonialCardName.value = centerCarousel ? centerCarousel.name : ''
        testimonialCardDesignation.value = centerCarousel ? centerCarousel.designation : ''
        testimonialCardReviewRateing.value = centerCarousel ? centerCarousel.reviewRateing : ''
      }
      const activeClass = document.querySelectorAll('.testimonials .owl-item.active')
      const owlIitem = document.querySelectorAll('.testimonials .owl-item')
      owlIitem.forEach((item) => {
        const img = item.querySelector('img')
        img.classList.remove('item-1', 'item-2', 'item-center')
        item.style.zIndex = ''
      })
      activeClass.forEach((item, index) => {
        const img = item.querySelector('img')
        img.classList.remove('item-1', 'item-2', 'item-center')
        item.style.zIndex = ''
      })
      activeClass.forEach((item, index) => {
        const img = item.querySelector('img')
        if (index == 0 || index == 4) {
          img.classList.add('item-1')
          item.style.zIndex = '1'
        }
        if (index == 1 || index == 3) {
          img.classList.add('item-2')
          item.style.zIndex = '2'
        }
        if (index == 2) {
          img.classList.add('item-center')
          item.style.zIndex = '3'
        }
      })
    }
    const testimonialCarouselAvtive = () => {
      const activeClass = document.querySelectorAll('.testimonials .owl-item.active')
      const owlIitem = document.querySelectorAll('.testimonials .owl-item')
      owlIitem.forEach((item) => {
        const img = item.querySelector('img')
        img.classList.remove('item-1', 'item-2', 'item-center')
        item.style.zIndex = ''
      })
      activeClass.forEach((item, index) => {
        const img = item.querySelector('img')
        if (index == 0 || index == 1) {
          img.classList.add('item-1')
          item.style.zIndex = '1'
        }
        if (index == 2 || index == 4) {
          img.classList.add('item-2')
          item.style.zIndex = '2'
        }
        if (index == 3) {
          img.classList.add('item-center')
          item.style.zIndex = '3'
        }
      })
    }
    onMounted(() => {
      const owl = $(testimonialCarousel.value)
      owl.owlCarousel({
        loop: true,
        center: true,
        items: 5,
        autoWidth: false,
        dots: false,
        touchDrag: false,
        mouseDrag: false,
        lazyLoad: true,
        autoplay: true,
        autoplayTimeout: 7000,
        smartSpeed: 3000,
        onInitialized: updateActiveTestimonial,
        onTranslated: updateActiveTestimonial,
        onTranslate: testimonialCarouselAvtive,
      })
    })

    return {
      testimonialCarousel,
      testimonials,
      testimonialCardText,
      testimonialCardName,
      testimonialCardDesignation,
      testimonialCardReviewRateing,
      getStarColor,
    }
  },
}
</script>

<style scoped>
.item-1 {
  transform: scale(0.973);
  transition: transform 1s ease-in-out, border-color 1s ease-in-out, border-width 1s ease-in-out;
}
.item-2 {
  transform: scale(1.11);
  border: 2px solid var(--primary-purple-300);
  transition: transform 1s ease-in-out, border-color 1s ease-in-out, border-width 1s ease-in-out;
}
.item-center {
  transform: scale(1.389);
  border: 2.5px solid var(--primary-purple-600);
  transition: transform 1s ease-in-out, border-color 1s ease-in-out, border-width 1s ease-in-out;
}
</style>
